module.exports = __webpack_public_path__ + "static/media/400026_02.3a922137.png";